import { Stack, Typography, useTheme } from "@mui/material";
import { ChevronRight } from "lucide-react";
import type { FC } from "react";
import { DashboardRowButton } from "web_myplann/Dashboard/Components/DashboardRowButton";

type Props = {
	title: string;
	subtotalText: string;
	onClick: () => void;
};

export const DashboardCategorySectionHeader: FC<Props> = ({
	title,
	subtotalText,
	onClick,
}) => {
	const { palette, iconSize } = useTheme();

	return (
		<DashboardRowButton onClick={onClick} showDivider={false}>
			<Typography variant="h4" flex={1}>
				{title}
			</Typography>
			<Stack direction="row" alignItems="center" gap={0.4} flexShrink={0}>
				<Typography variant="body2" color={palette.grey[500]} tabular>
					{subtotalText}
				</Typography>
				<ChevronRight size={iconSize.sm} color={palette.grey[400]} />
			</Stack>
		</DashboardRowButton>
	);
};
